import React, { useEffect, useState } from "react";
import blogIcons from './../../blogIcon';
import "./category.css";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../Config/Firebase/config";
import { toast } from "react-toastify";

const BlogCategory = ({setCategoryId, categoryId}) => {
  const [categoryData, setCategoryData] = useState([]);
  const [categoriesOpen, setCategoriesOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".categories-list")) {
        setCategoriesOpen(false);
      }
    };
    window.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", () => setCategoriesOpen(false));
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", () => setCategoriesOpen(false));
    };
  }, []);


  useEffect(() => {
    const categoryCollectionRef = collection(db, "categories");
    const getCategoryData = async () => {
      try {
        const data = await getDocs(categoryCollectionRef);
        const filteredData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setCategoryData(filteredData);
      } catch (error) {
        toast.error("Could not Load Blog Data");
      }
    };
    getCategoryData();
  }, []);

  
  const handleCategoriesOpen = (e) => {
    e.preventDefault();
    setCategoriesOpen(!categoriesOpen);
  };

  const handleSelectedCategory = async (e,id) => {
    e.preventDefault();
    setCategoryId(id);
    setCategoriesOpen(false);
  };

  return (
    <div className="categories">
      <div className="categories-icon" onClick={handleCategoriesOpen}>
        <i>{blogIcons.categoryIcon}</i>
      </div>
      <div className={categoriesOpen ? "categories-list" : "categories-list close"}>
        <h3 className="category-heading">Select Category</h3>
        <div className="categories-list-content">
          {categoryData.map((data) => (
            <h4
              className={categoryId === data.id ? "category-title category-selected" : "category-title"}
              key={data.id} 
              onClick={(e) => handleSelectedCategory(e, data.id)}
            >
              {data.title}
            </h4>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogCategory;
